import { useRef } from 'react';
import { useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'

import StatusOptionsMulti from '../components/psc/lib/StatusOptionsMulti'
import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useTableSlots from '../hooks/useTableSlots';
import useProjectContents from '../hooks/useProjectContents';
import useCustomerDocumentStatuses from '../hooks/useCustomerDocumentStatuses';

const CustomerDocuments = () => {
    const { projectID } = useParams()

    const table = useRef(null)
    const localStorageOrderKey = 'tblCustomerDocumentsOrder'
    const defaultOrder = [[ 0, 'desc' ]]
    
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isLoading = pscState.isLoading

    const { currentUser } = useAuthentication();

    const {
        userHasProjectAccessLevel,
        isUserManagementInitialized
    } = useUserManagement()

    const {
        isCustomerDocumentsLoaded,
        customerDocuments,
    } = useProjectContents();

    const { customerDocumentStatuses } = useCustomerDocumentStatuses();

    const {
        filePathSlot,
        dateSlot,
        linkSlot,
    } = useTableSlots();

    const columns = [
        { data: 'final_version_file_path' },
        { data: 'created_at' },
        { data: 'reference' },
        { data: 'title' },
        { data: 'std_document.name' },
        { data: 'organisation_code' },
        { data: 'customer_document_status.name' }
    ]

    const tableHead = (
        <tr>
            <th style={{width: '25px'}}>&nbsp;</th>
            <th>Added</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Type</th>
            <th>Customer</th>
            <th>Status</th>
        </tr>
    )
    
    const tableSlots = {
        0: filePathSlot,
        1: dateSlot,
        2: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/customer_documents/${row.id}`),
        3: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/customer_documents/${row.id}`),
    }

    const newButton = project && userHasProjectAccessLevel(currentUser,project.id, 'MEMBER')
        ? ( <Link type="button" className="btn btn-mr btn-primary" to={`/portfolio/${projectID}/customer_documents/new`}>New Customer Document</Link> )
        : null

    const showLoading = isLoading || !isUserManagementInitialized || !isCustomerDocumentsLoaded
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Customer Documents</h2>

                            {newButton}

                            <div key="newText1" style={{color: "rgba(103, 106, 108, 0.65)"}}>
                                Customer Documents are <b>not version-controlled</b> by GNC Go. References are <b>defined by the issuing organisation</b>.
                            </div>

                            <div key="newText2" style={{color: "rgba(103, 106, 108, 0.65)"}}>
                                Customer Documents <strong>can be superseded</strong> by a <strong>manually-defined</strong> upversion.
                            </div>
                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="6"
                                    data={customerDocumentStatuses}
                                    localStorageKey="customer_document-list-statuses"
                                />
                            </div>

                            { showLoading ? <Loading /> : (
                            <GncDataTable
                                tableRef={table}
                                data={customerDocuments}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerDocuments
